import _ from 'lodash'

import {
  SHOW_MODAL,
  HIDE_MODAL,
  LOCK,
  UNLOCK,
} from 'react-redux/actions/modal'

import { RESET } from 'react-redux/actions/app'

const initialState = {
  component: null, // react component or null
  title: null, // modal title
  locked: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET: {
      return _.cloneDeep(initialState)
    }
    case SHOW_MODAL: {
      return Object.assign(
        {},
        state,
        {component: action.component, title: action.title}
      )
    }
    case HIDE_MODAL: {
      return Object.assign({}, state, initialState)
    }
    case LOCK: {
      return Object.assign({}, state, { locked: true })
    }
    case UNLOCK: {
      return Object.assign({}, state, { locked: false })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/react-redux/reducers/modal.js